<template>
  <!-- eslint-disable vue/max-attributes-per-line vue/no-static-inline-styles -->
  <section class="rl-postbacks">
    <div class="card wavebg !tw-w-full">
      <div class="!tw-flex rl-header !tw-justify-between !tw-items-center">
        <button class="btn btn-outline-primary btn-sm">
          &lt; Back
        </button>
        <div class="rl-postbacks__controls-wrapper !tw-items-center">
          <div class="empty-select">
            Not Specified
          </div>
          <div
            class="empty-pagination tw-ml-8 mobile:tw-ml-0"
            style="width: 269px"
          >
            <div
              class="empty-select mr-8"
              style="width: 80px"
            >
              100
            </div>
            <span class="tw-whitespace-nowrap">&lt; &lt;&lt; Page</span>
            <div class="form-group mb-0 mt-0">
              <input
                placeholder="1"
                class="form-control mt-0 pl-16 pr-16"
                style="width: 40px"
              >
            </div>
            <span class="tw-whitespace-nowrap">of 2 &gt; &gt;&gt;</span>
          </div>
        </div>
      </div>
      <div class="table-empty mt-16 mb-8">
        <div class="table-empty__head" />
        <div class="table-empty__body" />

        <div class="mob-table__block mob-table__block-first pt-0">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
        </div>
        <div class="mob-table__block">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
        </div>
        <div class="mob-table__block">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.rl-postbacks {
  &__controls-wrapper {
    display: flex;
  }

  @media (max-width: 650px) {
    &__controls-wrapper {
      width: 100%;
      flex-direction: column;
      > .empty-select {
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
}

.rl-header {
  @media (max-width: 650px){
    flex-direction: column;

    .btn-sm, 
    .empty-select {
      width: 100%;
    }
  }
}
</style>
